import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DichiarazioneDTO } from '../../models/dichiarazione-dto';

@Component({
	selector: 'lib-accettazione',
	templateUrl: './accettazione.component.html',
	styleUrls: ['./accettazione.component.css']
})
export class AccettazioneComponent implements OnInit {
	form: FormGroup;

	@Input()
	dichiarazioni: Array<DichiarazioneDTO>;

	@Input()
	isPersonaGiuridica: boolean;

	@Input()
	tipologiaDichiarazioni: Array<string>;

	@Output()
	completeProcess: EventEmitter<Array<DichiarazioneDTO>> = new EventEmitter<Array<DichiarazioneDTO>>();

	@Output()
	salvaBozza: EventEmitter<Array<DichiarazioneDTO>> = new EventEmitter<Array<DichiarazioneDTO>>();

	@Output()
	previousStep: EventEmitter<Array<DichiarazioneDTO>> = new EventEmitter<Array<DichiarazioneDTO>>();

	direction: string = 'only-backward';
	isFinal: boolean = true;
	
	constructor() { }

	ngOnInit() {
		this.form = new FormGroup({});
		const chk1 = new FormControl({ value: false, disabled: false },
			[Validators.required]);
		this.form.addControl('chk1', chk1);
		const chk2 = new FormControl({ value: false, disabled: false },
			[Validators.required]);
		this.form.addControl('chk2', chk2);
		const chk3 = new FormControl({ value: false, disabled: false },
			[Validators.required]);
		this.form.addControl('chk3', chk3);
		const chk4 = new FormControl({ value: false, disabled: false },
			[Validators.required]);
		this.form.addControl('chk4', chk4);
		const chk5 = new FormControl({ value: false, disabled: false },
			[Validators.required]);
		this.form.addControl('chk5', chk5);
		const chk6 = new FormControl({ value: false, disabled: false },
			[Validators.required]);
		this.form.addControl('chk6', chk6);

		if (!this.dichiarazioni) {
			this.initDichiarazione();
		}
	}

	forward($event: any) { }

	backward($event: any) {
		this.previousStep.emit(this.dichiarazioni);
	}

	complete($event: any) {
		this.setFormFieldControls();
		this.completeProcess.emit(this.dichiarazioni);
	}

	onSalvaBozza($event: any) {
		this.setFormFieldControls();
		this.salvaBozza.emit(this.dichiarazioni);
	}

	isFormValid(): boolean {
		return this.form.valid &&
			this.form.controls['chk1'].value &&
			this.form.controls['chk2'].value &&
			this.form.controls['chk3'].value &&
			this.form.controls['chk4'].value &&
			this.form.controls['chk5'].value &&
			((this.isPersonaGiuridica && this.form.controls['chk6'].value) || !this.isPersonaGiuridica);
	}

	initDichiarazione() {
		this.dichiarazioni = new Array<DichiarazioneDTO>();
	}

	setFormFieldControls() {
		
		this.initDichiarazione();

		const dati1 = new DichiarazioneDTO();
		dati1.isChecked = this.form.controls['chk1'].value;
		dati1.dichiarazione = "1";
		this.dichiarazioni.push(dati1);

		const dati2 = new DichiarazioneDTO();
		dati2.isChecked = this.form.controls['chk2'].value;
		dati2.dichiarazione = "2";
		this.dichiarazioni.push(dati2);

		const dati3 = new DichiarazioneDTO();
		dati3.isChecked = this.form.controls['chk3'].value;
		dati3.dichiarazione = "3";
		this.dichiarazioni.push(dati3);

		const dati4 = new DichiarazioneDTO();
		dati4.isChecked = this.form.controls['chk4'].value;
		dati4.dichiarazione = "4";
		this.dichiarazioni.push(dati4);

		const dati5 = new DichiarazioneDTO();
		dati5.isChecked = this.form.controls['chk5'].value;
		dati5.dichiarazione = "5";
		this.dichiarazioni.push(dati5);

		const dati6 = new DichiarazioneDTO();
		dati6.isChecked = this.form.controls['chk6'].value;
		dati6.dichiarazione = "6";
		this.dichiarazioni.push(dati6);
	}
}